export const southdakotaCountiesList = [
    'Aurora',
    'Beadle',
    'Bennett',
    'Bon Homme',
    'Brookings',
    'Brown',
    'Brule',
    'Buffalo',
    'Butte',
    'Campbell',
    'Charles Mix',
    'Clark',
    'Clay',
    'Codington',
    'Corson',
    'Custer',
    'Davison',
    'Day',
    'Deuel',
    'Dewey',
    'Douglas',
    'Edmunds',
    'Fall River',
    'Faulk',
    'Grant',
    'Gregory',
    'Haakon',
    'Hamlin',
    'Hand',
    'Hanson',
    'Harding',
    'Hughes',
    'Hutchinson',
    'Hyde',
    'Jackson',
    'Jerauld',
    'Jones',
    'Kingsbury',
    'Lake',
    'Lawrence',
    'Lincoln',
    'Lyman',
    'McCook',
    'McPherson',
    'Marshall',
    'Meade',
    'Mellette',
    'Miner',
    'Minnehaha',
    'Moody',
    'Pennington',
    'Perkins',
    'Potter',
    'Roberts',
    'Sanborn',
    'Shannon',
    'Spink',
    'Stanley',
    'Sully',
    'Todd',
    'Tripp',
    'Turner',
    'Union',
    'Walworth',
    'Yankton',
    'Ziebach',
    ]